module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/link-4e317cfcfbab1f334a08fecc5eb98cd3.png";